module.exports = __webpack_public_path__ + "static/media/077fb69f.jpg";